import { xyFilterX } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function filterX(data, options = {}) {
    return {
        data: xyFilterX(data, options),
    };
}
//# sourceMappingURL=filterX.js.map